import { Injectable } from '@angular/core';

import { Observable, map } from 'rxjs';

import { ExtendedTab } from '@hdms/shared/common-types';

import { getNavigationTabs, staticTabList } from '../utils/navigation-tabs.config';

import { AccessService } from './access.service';

@Injectable({
  providedIn: 'root'
})
export class TpmNavigationService {
  constructor(private readonly accessService: AccessService) {}

  public getNavigation$(): Observable<ExtendedTab[]> {
    return this.accessService
      .getData$()
      .pipe(map(_ => (this.accessService.isTpmEnabled() ? getNavigationTabs(this.accessService) : [])));
  }

  public getStaticTabNavigation(): ExtendedTab[] {
    return getNavigationTabs(null, staticTabList);
  }
}
